import React from 'react';
import UnidAndStores from '../../../../components/trades/UnitsAndStores';

export default ({
  coat,
  shirt,
  onChangeStore,
  onChangeUnit,
  stores,
  selectedUnit,
  selectedStore,
  cleark,
}) => (
  <div>
    <div className="bx--row">
      <div className="bx--col-xs-12">
        <p className="description-option-title ">Confirme sua Solicitação de Kit</p>
        <p className="description-option-desc">Confira se as medidas estão de acordo.</p>
        <div className="mg-top-40 confirm-troca">
          <p className="mg-top-20">
            <strong>Camisetas </strong> 
            {' '}
            <span> 
              {' '}
              {shirt}
              {' '}
            </span>
          </p>
          <p className="mg-top-20">
            <strong>Agasalho </strong> 
            {' '}
            <span> 
              {' '}
              {coat}
              {' '}
            </span>
          </p>
        </div>
      </div>
    </div>

    <div className="stores-units-trades">
      <h2>Qual a loja principal deste atendente.</h2>
      <p>
        Selecione abaixo a loja principal de 
        {' '}
        <span> 
          {' '}
          {cleark.label}
          {' '}
        </span>
      </p>
      <div className="mg-top-20">
        <UnidAndStores
          onChangeStore={onChangeStore}
          onChangeUnit={onChangeUnit}
          stores={stores}
          urlUnits={`/Atendente/GetUnidades/${cleark.id}`}
          selectedUnit={selectedUnit}
          selectedStore={selectedStore}
        />
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/screens/client/trades/uniforms/ConfirmRequestUniform.jsx